import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  isCollapsed = signal(false);

  // 1. Create a Subject to emit events
  private triggerMethodSource = new Subject<void>();

  // 2. Expose it as an observable for the Sidebar to subscribe to
  triggerMethod$ = this.triggerMethodSource.asObservable();

  // 3. Method for the Social Page to call
  callSidebarMethod() {
    this.triggerMethodSource.next();
  }

  toggleCollapse() {
    this.isCollapsed.update(val => !val);
  }

  setCollapsed(val: boolean) {
    this.isCollapsed.set(val);
  }
}
